module.exports = __webpack_public_path__ + "57830825720d6bdd9b4c0fe85ed5d63d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/footer.png
// module id = 4I4m
// module chunks = 3